/* OREN — Welle 1: Type-Out + Scroll-Path + Ink-Drops (v2) */
(function(){
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ============================================
     TYPE-OUT v2 — only on .section-title (blue headlines)
     Slower (50ms/char), keeps content after animation,
     pauses caret 4s, then gentle fade.
     ============================================ */
  function setupTypeOut(){
    // ONLY target the navy/blue section headlines — not every h1/h2/h3
    const candidates = document.querySelectorAll('.section-title:not([data-typeout-done])');
    if(!candidates.length) return;

    candidates.forEach(function(el){
      if(el.dataset.typeoutInit === '1') return;
      el.dataset.typeoutInit = '1';

      // Save original HTML — we restore it intact at the end
      const originalHTML = el.innerHTML;
      el.dataset.typeoutOriginal = originalHTML;

      // Wrap setup: hide the real content with a measuring container,
      // animate inside an overlay, then swap back to clean original.
      el.classList.add('typeout');
      el.innerHTML = ''+
        '<span class="typeout-final" style="opacity:0;">' + originalHTML + '</span>'+
        '<span class="typeout-anim" aria-hidden="true"></span>'+
        '<span class="typeout-caret" aria-hidden="true"></span>';
    });

    const io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(!en.isIntersecting) return;
        const el = en.target;
        if(el.classList.contains('is-typing') || el.classList.contains('is-done')) return;
        startTyping(el);
        io.unobserve(el);
      });
    }, { threshold: 0.2 });

    candidates.forEach(function(el){ io.observe(el); });
  }

  function startTyping(el){
    el.classList.add('is-typing');
    const anim = el.querySelector('.typeout-anim');
    const finalEl = el.querySelector('.typeout-final');
    if(!anim || !finalEl) return;

    const fullHTML = el.dataset.typeoutOriginal || finalEl.innerHTML;
    const tokens = tokenize(fullHTML);

    let i = 0;
    const speed = 55; // ms per character — langsamer, lesbarer
    const variance = 18;

    function step(){
      if(i >= tokens.length){
        // Finished — swap to clean original (preserves all classes/spans)
        finishTyping(el);
        return;
      }
      anim.innerHTML += tokens[i];
      i++;
      setTimeout(step, speed + (Math.random() * variance - variance/2));
    }
    // tiny initial delay so caret blinks once before typing starts
    setTimeout(step, 280);
  }

  function finishTyping(el){
    const anim = el.querySelector('.typeout-anim');
    const finalEl = el.querySelector('.typeout-final');
    // Make the real content visible (with proper .it italics etc.)
    if(finalEl) finalEl.style.opacity = '1';
    // Hide the typing animation overlay
    if(anim) anim.style.display = 'none';
    el.classList.remove('is-typing');
    el.classList.add('is-done');
    el.dataset.typeoutDone = '1';
    // Caret stays for 4s then fades via CSS
  }

  function tokenize(html){
    const tokens = [];
    let i = 0;
    while(i < html.length){
      if(html[i] === '<'){
        const end = html.indexOf('>', i);
        if(end === -1){ tokens.push(html.slice(i)); break; }
        tokens.push(html.slice(i, end + 1));
        i = end + 1;
      } else if(html[i] === '&'){
        const end = html.indexOf(';', i);
        if(end === -1){ tokens.push(html[i]); i++; }
        else { tokens.push(html.slice(i, end + 1)); i = end + 1; }
      } else {
        tokens.push(html[i]);
        i++;
      }
    }
    return tokens;
  }

  /* ============================================
     SCROLL-PATH — unchanged from v1
     ============================================ */
  function setupScrollPath(){
    const sections = Array.from(document.querySelectorAll('main section, main .hero-immersive'));
    if(sections.length < 3) return;

    const path = document.createElement('div');
    path.className = 'scroll-path';
    document.body.appendChild(path);

    const dots = [];
    sections.forEach(function(sec, idx){
      const labelText = getLabelForSection(sec, idx);
      const dot = document.createElement('div');
      dot.className = 'scroll-path-dot';
      dot.dataset.cursor = 'Jump';
      const lbl = document.createElement('span');
      lbl.className = 'label';
      lbl.textContent = labelText;
      dot.appendChild(lbl);
      dot.addEventListener('click', function(){
        sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      path.appendChild(dot);
      dots.push({ dot: dot, section: sec });
    });

    let visible = false;
    let ticking = false;
    function update(){
      const y = window.scrollY;
      const viewportMid = y + window.innerHeight * 0.4;
      if(y > 200 && !visible){ path.classList.add('visible'); visible = true; }
      if(y <= 200 && visible){ path.classList.remove('visible'); visible = false; }
      let activeIdx = 0;
      dots.forEach(function(d, i){
        const rect = d.section.getBoundingClientRect();
        const top = rect.top + window.scrollY;
        if(top <= viewportMid) activeIdx = i;
      });
      dots.forEach(function(d, i){
        d.dot.classList.toggle('active', i === activeIdx);
      });
      const activeSec = dots[activeIdx].section;
      const isDark = activeSec.classList.contains('navy') ||
                     activeSec.classList.contains('hero-immersive') ||
                     getComputedStyle(activeSec).backgroundColor === 'rgb(20, 42, 110)';
      path.classList.toggle('on-dark', isDark);
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if(!ticking){ requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function getLabelForSection(sec, idx){
    const labelEl = sec.querySelector('.section-label, .styled-with-label');
    if(labelEl){
      let txt = labelEl.textContent.trim();
      txt = txt.replace(/^\/\/\s*/, '');
      const m = txt.match(/section\s*(\d+)/i);
      if(m) return 'Section ' + m[1].padStart(2, '0');
      if(txt.length > 22) txt = txt.slice(0, 22) + '…';
      return txt;
    }
    if(sec.classList.contains('hero-immersive')) return 'Top';
    return String(idx + 1).padStart(2, '0');
  }

  /* ============================================
     INK-DROPS — unchanged
     ============================================ */
  function setupInkDrops(){
    document.addEventListener('click', function(e){
      if(e.clientX === 0 && e.clientY === 0) return;
      const drop = document.createElement('div');
      drop.className = 'ink-drop';
      drop.style.left = e.clientX + 'px';
      drop.style.top = e.clientY + 'px';
      let el = e.target;
      let isDark = false;
      while(el && el !== document.body){
        if(el.classList && (el.classList.contains('navy') ||
           el.classList.contains('ticker') ||
           el.classList.contains('footer') ||
           el.classList.contains('hero-immersive'))){
          isDark = true;
          break;
        }
        el = el.parentElement;
      }
      if(isDark) drop.classList.add('on-dark');
      document.body.appendChild(drop);
      setTimeout(function(){ drop.remove(); }, 1700);
    }, { passive: true });
  }

  function init(){
    setupTypeOut();
    setupScrollPath();
    setupInkDrops();
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
